import { render, staticRenderFns } from "./PurchaseAndSaleCategoryCompare.vue?vue&type=template&id=6885fc21&scoped=true"
import script from "./PurchaseAndSaleCategoryCompare.vue?vue&type=script&lang=js"
export * from "./PurchaseAndSaleCategoryCompare.vue?vue&type=script&lang=js"
import style0 from "./PurchaseAndSaleCategoryCompare.vue?vue&type=style&index=0&id=6885fc21&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6885fc21",
  null
  
)

export default component.exports